import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "./Logo";

const NAV_LINKS = [
  { label: "Features", href: "#features" },
  { label: "Modules", href: "#modules" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "About", href: "#about" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur shadow-sm" : "bg-white"
      }`}
    >
      <div className="max-w-[1280px] mx-auto flex items-center justify-between px-6 py-3">
        <Link to="/" className="flex items-center">
          <Logo size="md" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-sm font-medium text-slate-700 hover:text-[#14B8A6] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => nav("/login")}
            className="text-sm font-semibold text-[#0F2A5F] hover:text-[#0A1E4A] px-4 py-2 transition-colors"
          >
            Sign in
          </button>
          <button
            onClick={() => nav("/register")}
            className="bg-[#14B8A6] hover:bg-[#0F8A7D] text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors shadow-sm hover:shadow-md"
          >
            Get started →
          </button>
        </div>

        <button
          className="md:hidden text-slate-700"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="toggle menu"
        >
          {mobileOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 px-6 py-4 flex flex-col gap-3">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-slate-700 py-1.5"
            >
              {l.label}
            </a>
          ))}
          <div className="flex gap-2 pt-2 border-t border-slate-100">
            <button
              onClick={() => { setMobileOpen(false); nav("/login"); }}
              className="flex-1 text-sm font-semibold text-[#0F2A5F] border border-slate-300 px-4 py-2 rounded-lg"
            >
              Sign in
            </button>
            <button
              onClick={() => { setMobileOpen(false); nav("/register"); }}
              className="flex-1 bg-[#14B8A6] text-white text-sm font-semibold px-4 py-2 rounded-lg"
            >
              Get started
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
